import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { useTheme} from '@mui/material/styles'

export type PatientIdentityIconProps = SvgIconProps

export function PatientIdentityIcon(props: PatientIdentityIconProps) {
  const { htmlColor } = props
  const theme = useTheme()
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Patient_identity">
        <g>
          <g id="XMLID_00000137833462946564673320000008218884057232464768_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M112.183,69.605v-0.57v-14.26h68.83c4.95,0,8.99,4.04,8.99,8.98v99.29
					c0,4.94-4.04,8.98-8.99,8.98H18.983c-4.94,0-8.98-4.04-8.98-8.98v-99.29c0-4.94,4.04-8.98,8.98-8.98h66.92h1.92v14.26v0.57
					H112.183z M94.853,157.795v-73.27h-68.82v73.27h11.05h42.86H94.853z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M112.183,54.775h68.83
					c4.95,0,8.99,4.04,8.99,8.98v99.29c0,4.94-4.04,8.98-8.99,8.98H18.983c-4.94,0-8.98-4.04-8.98-8.98v-99.29
					c0-4.94,4.04-8.98,8.98-8.98h66.92"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="114.103"
                y1="97.785"
                x2="166.453"
                y2="97.785"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="114.103"
                y1="120.185"
                x2="166.453"
                y2="120.185"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="114.103"
                y1="142.595"
                x2="166.453"
                y2="142.595"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="87.823,69.035 
					87.823,54.775 87.823,27.975 112.183,27.975 112.183,54.775 112.183,69.035 				"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="76.643,69.605 
					87.823,69.605 112.183,69.605 123.363,69.605 				"
              />
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="37.083,157.795 
					26.033,157.795 26.033,84.525 94.853,84.525 94.853,157.795 79.943,157.795 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M37.083,157.795v-17.01c0.19-1.66,0.63-3.95,1.71-6.25c1.07-2.31,2.78-4.64,5.51-6.37c1.56-1.03,3.15-1.62,4.55-1.99
					c0.02,0,0.02,0,0.02,0c3.12,2.32,6.46,3.46,9.67,3.38c0.12,0,0.23,0,0.35,0c3.14,0,6.37-1.14,9.38-3.34
					c1.38,0.37,2.93,0.97,4.43,1.95c5.57,3.57,6.91,9.55,7.24,12.85"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="46.983"
                y1="157.525"
                x2="46.983"
                y2="142.775"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="70.293"
                y1="157.525"
                x2="70.293"
                y2="142.775"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M70.613,106.595c-0.65-2.12-1.72-4.36-3.62-5.07c-2.36-0.88-4.24,1-7.87,1.2c-0.18,0.01-0.35,0.01-0.52,0.01
					c-0.18,0-0.35,0-0.53-0.01c-3.63-0.2-5.51-2.08-7.87-1.2c-1.89,0.71-2.99,2.95-3.63,5.07c0,0.01,0,0.01,0,0.02
					c0-0.01,0-0.01-0.01-0.02c-0.34-0.9-1.19-3.71-0.25-6.9c0.26-0.88,1.07-3.24,3.3-5.07c3.07-2.52,7.06-2.55,8.63-2.56
					c0.07,0,0.13,0,0.16,0c0.06,0,0.13,0,0.2,0c0.06,0,0.13,0,0.2,0c0.03,0,0.08,0,0.15,0c1.58,0.01,5.56,0.04,8.64,2.56
					c2.22,1.83,3.04,4.19,3.29,5.07c0.94,3.19,0.07,6-0.26,6.9c-0.01,0.01-0.01,0.01-0.01,0.02
					C70.613,106.605,70.613,106.605,70.613,106.595z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M70.613,106.595h0.01c0.27,0.04,0.52,0.13,0.74,0.28c1.43,0.95,0.6,3.82,0.49,4.15c-0.41,1.37-1.24,2.26-1.72,2.68
					c-0.31,1.23-1.3,4.45-4.29,7.02c-0.65,0.55-3.63,3.1-7.14,3.01c-0.04,0-0.07,0-0.1,0c-0.04,0-0.07,0-0.09,0
					c-3.53,0.09-6.51-2.46-7.16-3.01c-2.99-2.57-3.98-5.79-4.29-7.02c-0.48-0.42-1.31-1.31-1.72-2.68c-0.11-0.33-0.94-3.2,0.49-4.15
					c0.22-0.14,0.46-0.24,0.73-0.28h0.01"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="79.943"
                y1="157.795"
                x2="79.943"
                y2="141.015"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default PatientIdentityIcon
